<!-- 推送BD工单 -->
<template>
  <div class="doc-register">
    如无法触达或未完成该项任务，推送BD处理。
    <span @click="beforePush">推送BD工单>></span>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import { Modal, message as Message } from 'ant-design-vue'
import { pushBdOrder } from '@/api/workPlace/workOrder'
import { createVNode } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { get as Get } from 'lodash'
const prop = defineProps({
  groupInfo: {
    type: Object,
    default: () => {}
  },
  groupId: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['hideRegisterEnter'])

const beforePush = () => {
  Modal.confirm({
    title: '发送BD工单',
    icon: () => createVNode(ExclamationCircleOutlined),
    content: '确认向BD推送“医生注册成功”工单？',
    centered: true,
    onOk() {
      pushOrder()
    },
    onCancel() {
      //
    }
  })
}
const pushOrder = () => {
  const query = {
    doctorId: Get(prop.groupInfo, 'doctorInfo.businessId'),
    doctorUserId: Get(prop.groupInfo, 'doctorInfo.ucUserId'),
    messageGroupId: prop.groupId,
    doctorName: Get(prop.groupInfo, 'doctorInfo.username'),
    bdId: Get(prop.groupInfo, 'bindAssistant.businessId'),
    bdUserId: Get(prop.groupInfo, 'bindAssistant.ucUserId'),
    bdUserName: Get(prop.groupInfo, 'bindAssistant.username'),
    assistantWorkOrderId: Get(prop.groupInfo, 'targetWorkOrder.workOrderId')
  }

  pushBdOrder(query).then(res => {
    const { message } = res || {}
    if (message) {
      Modal.info({
        centered: true,
        title: '提示',
        content: message,
        onOk() {
          emit('hideRegisterEnter')
        }
      })
    } else {
      Message.success('推送成功！')
      emit('hideRegisterEnter')
    }
  })
}
</script>
<style scoped lang="scss">
.doc-register {
  height: 100%;
  padding-left: 15px;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  display: flex;
  align-items: center;
  span {
    color: #1890ff;
    margin-left: 12px;
    cursor: pointer;
  }
}
</style>
